var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bar-grafico"},[_c('BarraGrafico',{attrs:{"type":"BarChart","data":_vm.dados,"options":_vm.options}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }